module.exports = __webpack_public_path__ + "static/media/48275343_2308759735865871_6843666258848645120_o-thumb.bd40b333.jpg";